import type { ReactNode } from 'react';
import { components } from 'react-select';

import Icon from '@zen/DesignSystem/Icon';

const Option: typeof components.Option = (props) => {
  const renderChildren = (): ReactNode => {
    if (props.isSelected) {
      return (
        <div className="flex items-center justify-between gap-2">
          <span>{props.children}</span>
          <Icon className="text-azure-base" icon="zicon-tick" />
        </div>
      );
    }

    return props.children;
  };

  return components.Option && <components.Option {...props}>{renderChildren()}</components.Option>;
};

export default Option;
